// extracted by mini-css-extract-plugin
export var container = "_65-0";
export var icon = "_65-1";
export var text = "_65-2";